import React, { useState } from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useTheme } from "@mui/material";
import SyntaxHighlighter from "react-syntax-highlighter";
import { a11yDark, a11yLight } from "react-syntax-highlighter/dist/cjs/styles/hljs";
import CopyToClipboardWrapper from "../CopyToClipboardWrapper";
import HoverOverlay from "../HoverOverlay";

interface FormattedTextAreaProps {
  value: string | null;
  language: string;
}

export function FormattedTextArea({ value, language }: FormattedTextAreaProps) {
  const theme = useTheme();
  const [copied, setCopied] = useState(false);
  const isDarkMode = theme.palette.mode === "dark";

  return (
    <CopyToClipboardWrapper value={value} onCopied={() => setCopied(true)}>
      <HoverOverlay
        disabled={!value}
        hoverText={copied ? "Copied!" : "Copy To Clipboard"}
        hoverIcon={<ContentCopyIcon />}
      >
        <SyntaxHighlighter
          data-testid="syntax-highlighter"
          showLineNumbers
          language={language}
          style={isDarkMode ? a11yDark : a11yLight}
          customStyle={{
            borderColor: theme.palette.divider,
            borderWidth: 1,
            margin: 0,
          }}
          codeTagProps={{
            style: {
              backgroundColor: "transparent",
            },
          }}
          role="code"
        >
          {value}
        </SyntaxHighlighter>
      </HoverOverlay>
    </CopyToClipboardWrapper>
  );
}
